import { type ActionFlowNode, useAtomData } from '@lighthouse/shared'
import isDeepEqual from 'fast-deep-equal'
import React, { memo, useMemo } from 'react'

import { otherPlatformListAtom } from '@/atoms/application/state'

import { useErrorMap } from '../../hook/useErrorMap'
import { validateNode } from '../../utils/nodeValidator'
import { NodeSourceHandle, NodeTargetHandle } from '../Handle'
import NodeCard from './NodeCards'
import * as SC from './styles'

interface ActionNodeProps extends ActionFlowNode {
    isConnectable?: boolean
}

const ActionCommonNode: React.FC<ActionNodeProps> = props => {
    const { id, selected, data } = props
    const { nodeType, status, config } = data
    const accounts = useAtomData(otherPlatformListAtom)

    const errorMap = useErrorMap(config)
    // const a = useNodesData
    // 这个是前端校验，编辑时使用
    const errorMessage = useMemo(() => !validateNode(props, accounts) || errorMap?.[id], [errorMap, id, props, accounts])

    return (
        <SC.NodeWrapper selected={selected} status={status?.status}>
            <NodeCard errorMessage={errorMessage} nodeType={nodeType} data={data} nodeId={id} />
            <NodeSourceHandle {...props} />
            <NodeTargetHandle {...props} />
        </SC.NodeWrapper>
    )
}

const ActionNode: React.FunctionComponent<ActionNodeProps> = props => {
    const {
        data: { nodeType }
    } = props
    return <ActionCommonNode {...props} />
}

export default memo(ActionNode, (prevProps, nextProps) => {
    return isDeepEqual(prevProps.data, nextProps.data) && prevProps.selected === nextProps.selected
})
